<!-- [locked]="!(state?.algorithm_mode === 'Manual')" -->
<!-- [showActions]="state?.algorithm_mode === 'Manual'" -->
<app-touareg-control-state-layout
  [centralButton]="state.algorithm_mode === 'Manual'"
  [showSearch]="state.algorithm_mode === 'Manual'"
  [locked]="!(state.algorithm_mode === 'Manual')"
  [showActions]="state.algorithm_mode === 'Manual'"
  (onSuggestion)="onSuggestion($event)"
  (onSelection)="onSelection($event)"
  (onManualAdd)="onManualAdd($event)"
  (deSelection)="deSelection($event)"
>
  <!-- MODE AUTO  -->
  <!-- CENTER ZONE-->
  <button
    *ngIf="isAutoMode"
    slot-middle
    mat-flat-button
    color="primary"
    class="w-100 h-100 btn-green"
    [disabled]="modeFetching || modeLockFetching"
    (click)="setLockMode($event)"
    title="Lock this selection"
  >
    <span class="d-flex flex-center">
      <span *ngIf="modeLockFetching" class="mr-1">
        <mat-spinner diameter="15"></mat-spinner>
      </span>
      <mat-icon class="fs lock">lock_open</mat-icon>
    </span>
  </button>
  <!-- RIGHT ZONE-->
  <button
    *ngIf="isAutoMode"
    slot-right
    mat-flat-button
    color="primary"
    class="w-100 h-100 btn-red"
    title="Correct this selection"
    [disabled]="modeFetching || modeLockFetching"
    (click)="setManualMode($event)"
  >
    <span class="d-flex flex-center">
      <span *ngIf="modeFetching" class="mr-1">
        <mat-spinner diameter="15"></mat-spinner>
      </span>
      <span class="mode-btn"> Correct </span>
    </span>
  </button>

  <!-- MODE MANUEL  -->
  <!-- CENTER ZONE-->
  <button
    *ngIf="isManualMode"
    slot-middle
    mat-flat-button
    color="primary"
    class="w-100 h-100 btn-green"
    title="Lock this selection"
    [disabled]="modeFetching || modeLockFetching"
    (click)="setLockMode($event)"
  >
    <span class="d-flex flex-center">
      <span *ngIf="modeLockFetching" class="mr-1">
        <mat-spinner diameter="15"></mat-spinner>
      </span>
      <mat-icon class="fs lock">lock_open</mat-icon>
    </span>
  </button>
  <!-- RIGHT ZONE-->
  <button
    *ngIf="isManualMode"
    slot-right
    mat-flat-button
    color="primary"
    class="w-100 h-100"
    [disabled]="modeFetching || modeLockFetching"
    (click)="setAutoMode($event)"
  >
    <span class="d-flex flex-center">
      <span *ngIf="modeFetching" class="mr-1"
        ><mat-spinner diameter="15"></mat-spinner
      ></span>
      <span class="mode-btn">Back to auto</span>
    </span>
  </button>

  <!-- MODE LOCK  -->
  <!-- MIDDLE ZONE-->
  <button
    *ngIf="isLockMode"
    slot-middle
    mat-flat-button
    color="primary"
    class="w-100 h-100"
    title="Unlock this selection"
    [disabled]="modeLockFetching"
    (click)="setExitLockMode($event)"
  >
    <span class="d-flex flex-center">
      <span *ngIf="modeLockFetching" class="mr-1">
        <mat-spinner diameter="15"></mat-spinner>
      </span>
      <mat-icon class="fs lock">lock</mat-icon>
    </span>
  </button>
</app-touareg-control-state-layout>
